import { CloseRounded } from '@mui/icons-material';
import { Box, FormControl, IconButton, InputBase, OutlinedInput, Select, Typography, useTheme } from '@mui/material';
import { MenuItemStyled } from 'app/shared/layout/register/DefaultFormsComponents';
import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';

const EnumSelectTireAlert = ({ setAlertSearch, setActivePage, typeTireAlert }) => {
  const theme = useTheme();
  const [selectedValue, setSelectedValue] = useState('');

  const options = [
    { value: '', label: '' },
    { value: 'TIRE_ASSOCIATION', label: translate('fleetSenseApp.TireAlert.TIRE_ASSOCIATION') },
    { value: 'GROOVE_LIMIT', label: translate('fleetSenseApp.TireAlert.GROOVE_LIMIT') },
    { value: 'GROOVE_ODOMETER', label: translate('fleetSenseApp.TireAlert.GROOVE_ODOMETER') },
    { value: 'HIGH_PRESSURE', label: translate('fleetSenseApp.TireAlert.HIGH_PRESSURE') },
    { value: 'LOW_PRESSURE', label: translate('fleetSenseApp.TireAlert.LOW_PRESSURE') },
    { value: 'ROTATION_ODOMETER', label: translate('fleetSenseApp.TireAlert.ROTATION_ODOMETER') },
    { value: 'HIGH_TEMPERATURE', label: translate('fleetSenseApp.TireAlert.HIGH_TEMPERATURE') },
    { value: 'LOW_TEMPERATURE', label: translate('fleetSenseApp.TireAlert.LOW_TEMPERATURE') },
  ];

  const alertSensorOptions = [
    { value: '', label: '' },
    { value: 'HIGH_PRESSURE', label: translate('fleetSenseApp.TireAlert.HIGH_PRESSURE') },
    { value: 'LOW_PRESSURE', label: translate('fleetSenseApp.TireAlert.LOW_PRESSURE') },
    { value: 'HIGH_TEMPERATURE', label: translate('fleetSenseApp.TireAlert.HIGH_TEMPERATURE') },
    { value: 'LOW_TEMPERATURE', label: translate('fleetSenseApp.TireAlert.LOW_TEMPERATURE') },
  ];

  const alertStateOptions = [
    { value: '', label: '' },
    { value: 'GROOVE_LIMIT', label: translate('fleetSenseApp.TireAlert.GROOVE_LIMIT') },
    { value: 'GROOVE_ODOMETER', label: translate('fleetSenseApp.TireAlert.GROOVE_ODOMETER') },
    { value: 'ROTATION_ODOMETER', label: translate('fleetSenseApp.TireAlert.ROTATION_ODOMETER') },
  ];

  const filteredOptions = typeTireAlert === 'SENSOR' ? alertSensorOptions : typeTireAlert === 'STATE' ? alertStateOptions : options;

  useEffect(() => {
    setActivePage();
  }, [selectedValue]);

  const handleClearSearch = () => {
    setSelectedValue('');
    setAlertSearch('');
  };

  const handleSelectChange = event => {
    const value = event.target.value;
    setSelectedValue(value);
    if (value === '') {
      setAlertSearch('');
    } else {
      setAlertSearch(value);
    }
  };

  return (
    <FormControl>
      <Typography textAlign="left" color="text.primary" fontWeight="600" fontSize="16px">
        Alerta
      </Typography>
      <Select
        value={selectedValue}
        onChange={handleSelectChange}
        placeholder="Filtrar por Alerta"
        displayEmpty
        input={<OutlinedInput />}
        renderValue={selected => {
          if (!selected) {
            return <span style={{ color: theme.palette.text.secondary, fontSize: '15px' }}>{'Filtrar por Alerta'}</span>;
          }
          return translate(`fleetSenseApp.TireAlert.${selected}`);
        }}
        sx={{
          minWidth: '200px',
          height: '43px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            '&.Mui-focused fieldset': {
              border: `1px solid ${theme.palette.secondary.main}`,
            },
          },
          '& .MuiFormControl-root.MuiTextField-root': {
            '&:hover': {
              borderColor: theme.palette.secondary.main,
            },
          },
          '& fieldset': {
            top: '0',
            '& legend': {
              display: 'none',
            },
          },
          '& .MuiInputBase-input': {
            padding: '10px 16px',
            color: theme.palette.text.primary,
          },
        }}
        endAdornment={
          <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }} gap={3}>
            {selectedValue && (
              <>
                <IconButton onClick={handleClearSearch} edge="end">
                  <CloseRounded fontSize="small" color="error" />
                </IconButton>
              </>
            )}
          </Box>
        }
      >
        {filteredOptions.map((option, index) => (
          <MenuItemStyled key={index} value={option.value}>
            {option.label}
          </MenuItemStyled>
        ))}
      </Select>
    </FormControl>
  );
};

export default EnumSelectTireAlert;
